/* unplugin-vue-components disabled */import { render } from "./HeaderTabs.vue?vue&type=template&id=578823aa&scoped=true"
import script from "./HeaderTabs.vue?vue&type=script&lang=js"
export * from "./HeaderTabs.vue?vue&type=script&lang=js"

import "./HeaderTabs.vue?vue&type=style&index=0&id=578823aa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578823aa"]])

export default __exports__